import type { CompanyAddress } from "../../shared/types/link";
import { countryName } from "./countries";

/** An address as lines, as a letter writes it: the street, the town with its region and postcode, the country. */
export function addressLines(address: CompanyAddress | null): string[] {
  if (address === null) return [];
  const place = [address.city, address.region, address.postcode].filter((part): part is string => part !== null);
  return [
    address.line1,
    address.line2,
    place.length > 0 ? place.join(", ") : null,
    address.country ? countryName(address.country) : null,
  ].filter((line): line is string => line !== null);
}

/** A moment as people read one: "23 Oct 2026, 14:05". */
export function dateTime(at: number): string {
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(at));
}

/** What a field holds once typed: its text, or null for nothing but spaces. */
export function filled(value: string): string | null {
  return value.trim().length > 0 ? value.trim() : null;
}

/** Notes exactly as typed, every line kept, or null for nothing but spaces. */
export function notesOf(value: string): string | null {
  return value.trim().length > 0 ? value : null;
}
